import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { EfaOccProductAdapter } from './adapters/impl/efa-occ-product.adapter';
import { ProductAdapter } from '@spartacus/core';

@NgModule({ imports: [CommonModule], providers: [
        {
            provide: ProductAdapter,
            useClass: EfaOccProductAdapter,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class OccModule {}
